import { createDocumentPDFGenerator, defaultFilename } from './documentReportBase';

function quotationFilename(doc) {
  const rev = String(doc.revision || 1).padStart(2, '0');
  const base = defaultFilename(doc);
  return base.replace(/\.pdf$/, `_Rev${rev}.pdf`);
}

export const generateQuotationPDF = createDocumentPDFGenerator('ใบเสนอราคา', '#F7931E', quotationFilename);
